import imageCompression from "browser-image-compression"
import { setImageCompressing } from "store/reducers/commonReducer"
import store from "../../store/index"
import Swal from "sweetalert2"
import i18next from "i18next"
import { getAppToastOptions } from "utils/toastOptions"

export const handleFileChange = (
  event,
  fieldName,
  setFieldValue,
  width,
  height,
  maxSizeKB
) => {
  const fileInput = event.currentTarget
  const file = event.currentTarget.files[0]

  if (file) {
    const allowedMimeTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
    ]
    const fileName = (file.name || "").toLowerCase()
    const isAllowedType =
      allowedMimeTypes.includes((file.type || "").toLowerCase()) ||
      /\.(jpe?g|png|webp)$/.test(fileName)

    if (!isAllowedType) {
      Swal.fire(
        getAppToastOptions({
          icon: "error",
          title: i18next.t(
            "Please upload a valid image file (JPEG, PNG, or WebP)"
          ),
          timer: 4000,
        })
      )
      setFieldValue(fieldName, null)
      fileInput.value = ""
      return
    }

    const maxSize = maxSizeKB * 1024 // Convert KB to bytes

    // Check file size
    if (file.size > maxSize) {
      Swal.fire(
        getAppToastOptions({
          icon: "error",
          title: i18next.t(
            `File size should be less or equal to {{maxSizeKB}}KB`,
            { maxSizeKB }
          ),
          timer: 4000,
        })
      )
      setFieldValue(fieldName, null)
      fileInput.value = "" // Clear the input
      return
    }

    // Create an image element to check dimensions
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)
    img.src = objectUrl

    img.onload = () => {
      // Check if the image is square
      if (img.width === img.height) {
        setFieldValue(fieldName, file)
      } else {
        Swal.fire(
          getAppToastOptions({
            icon: "error",
            title: i18next.t(
              "Please upload a square image with recommended dimensions of {{width}} × {{height}} px.",
              { width, height }
            ),
            timer: 4000,
          })
        )
        setFieldValue(fieldName, null)
        fileInput.value = "" // Clear the input
      }
      URL.revokeObjectURL(objectUrl)
    }

    img.onerror = () => {
      Swal.fire(
        getAppToastOptions({
          icon: "error",
          title: i18next.t(
            "Please upload a valid image file (JPEG, PNG, or WebP)"
          ),
          timer: 4000,
        })
      )
      setFieldValue(fieldName, null)
      fileInput.value = ""
      URL.revokeObjectURL(objectUrl)
    }
  } else {
    setFieldValue(fieldName, null)
    fileInput.value = ""
  }
}

// export const handleFileChange = async (event, fieldName, setFieldValue) => {
//   const file = event.currentTarget.files[0]

//   if (file) {
//     store.dispatch(setImageCompressing(true))
//     try {
//       // Options for image compression
//       const options = {
//         maxSizeMB: 0.2, // Maximum file size in MB
//         maxWidthOrHeight: 1080, // Maximum width or height
//         useWebWorker: true, // Use web workers for better performance
//       }

//       // Compress the image file
//       const compressedFile = await imageCompression(file, options)

//       // Set the compressed file value
//       setFieldValue(fieldName, compressedFile)
//       console.log("Compressed")
//     } catch (error) {
//       console.error("File compression failed:", error)
//       // Handle errors (e.g., set an error message or revert to original file)
//       setFieldValue(fieldName, file)
//     } finally {
//       store.dispatch(setImageCompressing(false)) // End compressing
//     }
//   } else {
//     setFieldValue(fieldName, null)
//   }
// }

export const getImagePreviewSrc = (mode, values) => {
  if (mode === "add") {
    if (
      values.imageType === "URL" ||
      (values.imageType === "UPLOAD" &&
        values.imageUrl &&
        (values.imageFile === "" || values.imageFile === null))
    ) {
      return values.imageUrl
    } else {
      return values.imageFile ? URL.createObjectURL(values.imageFile) : null
    }
  } else {
    // In edit mode, assume we're using the existing image URL
    // return values.imageUrl
    return null
  }
}

export const getImagePreviewSrc2 = image => {
  if (!image) return null
  if (image instanceof File || image instanceof Blob) {
    return URL.createObjectURL(image)
  }
  if (typeof image === "string" && image.trim()) {
    return image
  }
  return null
}

// No required
export const handleFileChange2 = (event, fieldName, setFieldValue) => {
  const file = event.currentTarget.files[0]
  if (file) {
    setFieldValue(fieldName, file)
  } else {
    setFieldValue(fieldName, null)
  }
}
// Only size required
export const handleFileChange3 = (
  event,
  fieldName,
  setFieldValue,
  maxSizeKB
) => {
  const fileInput = event.currentTarget
  const file = event.currentTarget.files[0]
  if (file) {
    const maxSize = maxSizeKB * 1024
    // Check file size
    if (file.size > maxSize) {
      Swal.fire(
        getAppToastOptions({
          icon: "error",
          title: i18next.t(
            `File size should be less or equal to {{maxSizeKB}}KB`,
            { maxSizeKB }
          ),
          timer: 4000,
        })
      )
      setFieldValue(fieldName, null)
      fileInput.value = "" // Clear the input
      return
    } else {
      setFieldValue(fieldName, file)
    }
  } else {
    setFieldValue(fieldName, null)
  }
}

export const handle_4_3_FileUpload = (
  event,
  setFieldValue,
  fieldName,
  isMaxSize = false,
  maxSize = null
) => {
  const file = event.target.files[0]
  if (file) {
    // Check file size in KB
    const fileSizeInKB = file.size / 1024

    if (isMaxSize && fileSizeInKB > maxSize) {
      Swal.fire(
        getAppToastOptions({
          icon: "error",
          title: i18next.t(`File size must not exceed ${maxSize} KB`),
          timer: 4000,
        })
      )
      event.target.value = "" // Reset the file input
      return
    }

    const img = new Image()
    img.onload = function () {
      // Check if the image has a 4:3 aspect ratio
      const aspectRatio = this.width / this.height
      if (aspectRatio.toFixed(2) === (4 / 3).toFixed(2)) {
        setFieldValue(fieldName, file)
      } else {
        Swal.fire(
          getAppToastOptions({
            icon: "error",
            title: i18next.t("Please upload an image with a 4:3 aspect ratio"),
            timer: 4000,
          })
        )
        event.target.value = "" // Reset the file input
      }
    }
    img.onerror = function () {
      alert("Error loading image. Please try again.")
      event.target.value = "" // Reset the file input
    }
    img.src = URL.createObjectURL(file)
  }
}
